import {ajax_get, ajax_post} from "./index";

// 获取注册列表
export const getReginster = (data) => ajax_get('/museumreglist', data);
// 审批
export const shepi = (data) => ajax_post('/museumregapprove', data);
//获取附件列表
export const getFujianList = (data) => ajax_get('/museumannexfilelist', data);
//获取概述内容
export const getgaishuList = (data) => ajax_get('/museumextrainfo', data);
//保存概述内容
export const saveGaishu = (data) => ajax_post('/museumextrainfosave', data);
//获取评分列表
export const getScoreList= (data) => ajax_post('/scoredetail', data);
//导出评分
export const downloadScore = (data) => ajax_post('/scoredetailexp', data);
